enum BillingSecureEnum {
    SESAM = 'SESAM',
    SECURED = 'SECURED',
    UNSYNC = 'UNSYNC',
    DEGRADED = 'DEGRADED',
}
export default BillingSecureEnum;
